import { useMutation } from '@apollo/client';

import { EntityPagesArticleModuleUnfeatureArticleDocument } from '../graphql/mutations/entity-pages-article-module-unfeature-article.gql-types';

export const useUnfeatureArticleMutation = () => {
  return useMutation(EntityPagesArticleModuleUnfeatureArticleDocument);
};
